import { formatDateToMonthYear } from "../../utils/helperFunctions";
import { Card, CardContainer } from "../common/CardProps";
import { NothingToDisplay } from "./workComponent";
import styled from "styled-components";
import { useState } from "react";
import { useTheme } from "../../context/ThemeContext";
import editDark from "../../assets/images/editDark.png";
import editLight from "../../assets/images/editLight.png";
import deleteDark from "../../assets/images/deleteDark.png";
import deleteLight from "../../assets/images/deleteLight.png";
import { useNavigate } from "react-router-dom";
import { ImageIcon } from "../common/customImageProps";
import { useAuth } from "../../context/AuthContext";
import { errLog } from "../../utils/logger";
import { Images } from "../../config/ImagesExports";
import { useCommonConfig } from "../../hooks/useCommonConfig";
import { project } from "../../config/variables";
import useInterceptor from "../../hooks/useApiInterceptor";
import { useLoader } from "../../hooks/useLoader";
import { getErrorMessage } from "../../utils/errors";
import { Eye } from "lucide-react";

const MoreOptionMenu = styled.div`
  // border: 1px solid red;
  height: auto;
  border-radius: 10px;
  width: 250px;
  padding: 13px;
  background: ${({ theme }) => theme.body};
  box-shadow: ${({ theme }) => theme.shadowBox};
  position: absolute;
  top: -20px;
  z-index: 998;

  .closeBtn {
    background: rgba(255, 0, 0, 0.1);
    color: white;
    border: none;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 15px;

    &:hover {
      background: rgba(255, 0, 0, 1);
    }
    &:focus {
      background: darkred;
    }
  }

  .closeBtnAlignment {
    display: flex;
    justify-content: flex-end;
  }
`;

const MenuItem = styled.div`
  // border: 1px solid red;
  margin-top: 5px;
  display: flex;
  align-items: center;
  padding: 4px 10px;
  cursor: pointer;
  transition: background 0.3s ease;
  border-radius: 10px;

  &:hover {
    background: ${({ theme }) => theme.tinMenuHover};
  }

  img {
    margin-right: 10px;
  }
`;

const ProjectManage: React.FC = () => {
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";
  const navigate = useNavigate();
  const { showLoader, setShowLoader, LoaderComponent } = useLoader();
  const {
    isProjectLoading,
    fetchedProjects,
    FetchLoader,
    fetchProjects,
    showAlert,
    closeAlert,
  } = useAuth();
  const { isDark } = useCommonConfig();
  const defaultImage = isDark
    ? Images.placeholderLight
    : Images.placeholderDark;
  const api = useInterceptor();

  // Use a state variable to track the ID of the card with the open menu
  const [openOptionMenuId, setOptionMenuId] = useState<string | null>(null);

  // Toggle the option menu for a specific card
  const handleOptionMenu = (id: string) => {
    setOptionMenuId((prevId) => (prevId === id ? null : id));
  };

  // Functions for view, edit and delete actions
  const handleView = (id: string, projectName: string) => {
    navigate(`/dashboard/landing/project-view/${id}`, {
      state: {
        name: projectName,
      },//pass name to state
  }); //open edit page with specified project
  };
  const handleEdit = (id: string) => {
    navigate(`/dashboard/landing/edit-project/${id}`); //open edit page with specified project
  };

  const handleDelete = async (id: string, projectName: string) => {
    const url = `${project}/${id}`;
    showAlert(
      true,
      `Delete ${projectName}`,
      `You are about to delete ${projectName}`,
      true,
      undefined,
      async () => {
        try {
          setShowLoader(true);
          const response = await api.delete(url);
          if (response.data.success) {
            const successMessage = response.data.message;
            showAlert(
              false,
              "Delete Success",
              successMessage,
              false,
              undefined,
              undefined,
              false
            );
            setTimeout(() => {
              closeAlert(); //close alert
              setOptionMenuId(null); //close option menu
              fetchProjects(); //fetch updated projects to update UI
            }, 1250);
          }
        } catch (error) {
          const errMsg = getErrorMessage(error);
          errLog("DELETE PROJECT ERR: ", errMsg);
          showAlert(true, "Delete Error", errMsg, false);
        } finally {
          setShowLoader(false);
        }
      }
    );
  };



  return (
    <>
      {/* Loader during deleting */}
      {showLoader && LoaderComponent}

      {/* Loader during fetching */}
      {isProjectLoading && FetchLoader}

      {fetchedProjects && fetchedProjects.length > 0 ? (
        <CardContainer style={{ marginTop: "30px" }}>
          {fetchedProjects.map((project) => {
            const coverImage = project.galleryData.imgData.find(
              (img) => img.isCover
            );
            return (
              <Card key={project.id} className="classWidth">
                {openOptionMenuId === project.id && (
                  <MoreOptionMenu>
                    <div className="closeBtnAlignment">
                      <button
                        onClick={() => handleOptionMenu(project.id)}
                        className="closeBtn"
                      >
                        &#10005;
                      </button>
                    </div>
                    <MenuItem onClick={() => handleView(project._id ?? "", project.name)}>
                      <Eye size={20} style={{ marginRight: "10px" }} />
                      <span>View</span>
                    </MenuItem>
                    <MenuItem onClick={() => handleEdit(project._id ?? "")}>
                      <ImageIcon
                        src={isDarkMode ? editLight : editDark}
                        alt="Edit"
                        size="20px"
                      />
                      <span>Edit</span>
                    </MenuItem>
                    <MenuItem
                      onClick={() =>
                        handleDelete(project._id ?? "", project.name)
                      }
                    >
                      <ImageIcon
                        src={isDarkMode ? deleteLight : deleteDark}
                        alt="Delete"
                        width="15px"
                        height="19px"
                      />
                      <span>Delete</span>
                    </MenuItem>
                  </MoreOptionMenu>
                )}

                <button
                  key={project.id}
                  className="moreOpttionsBtn"
                  onClick={() => handleOptionMenu(project.id)}
                >
                  &#8942;
                </button>

                <img
                  src={coverImage?.src ?? defaultImage}
                  alt={coverImage?.alt || project.name}
                  className="imgContent"
                />

                <div className="content">
                  <span>
                    {" "}
                    {project.name.length > 25
                      ? `${project.name.slice(0, 25)}...`
                      : project.name}{" "}
                  </span>
                  <span>
                    {" "}
                    {project.dateStarted
                      ? formatDateToMonthYear(project.dateStarted)
                      : 0}{" "}
                  </span>
                </div>
              </Card>
            );
          })}
        </CardContainer>
      ) : (
        NothingToDisplay
      )}
    </>
  );
};

export default ProjectManage;
